module.exports = __webpack_public_path__ + "static/img/icomoon.e6b53e1.svg";


//////////////////
// WEBPACK FOOTER
// ./static/indexIcon/fonts/icomoon.svg?zhdtbr
// module id = L0du
// module chunks = 71